import type { AxiosRequestConfig } from 'axios'
import { z } from 'zod'

export interface WarehouseInfo {
  id: number
  name: string
  wmsWhCode: string
  warehouseType: string
}

export interface UserRole {
  id: number
  name: string
}

export interface UserInfo {
  assignedPickingZones: any[]
  createdAt: Date
  employeeCode: string
  firstName: string
  id: number
  lastName: string
  recordId: string
  skfRole: string
  updatedAt: Date
  username: string
  userReceiptEmail: boolean
  userRoles: UserRole[]
  warehouse: WarehouseInfo
  warehouseId: number
}

export interface GenericOption {
  id: string
  label: string
}

export interface TokenPayload {
  realm_access: {
    roles: string[]
  }
}

export interface OtpRole {
  id: string
  label: string
  iconName: string
}

export interface CommonHeaders {
  'x-hardcoded': boolean
  authorization: string
  'x-authorization-wms': string
  'x-authorization-core': string
  'x-justo-country': string
  'x-justo-warehouse'?: string
}

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  skipErrorAlert?: boolean
}

const createPageSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    data: z.array(itemSchema),
    limit: z.number(),
    page: z.number(),
    totalItems: z.number(),
    totalPages: z.number()
  })

const TransferSchema = z.object({
  transferId: z.string(),
  warehouse: z.string(),
  containersQty: z.number(),
  totalSKUs: z.number(),
  processedSKUs: z.number(),
  status: z.string(),
  docNum: z.string(),
  location: z.string().optional()
})

export const TransferPageSchema = createPageSchema(TransferSchema)

export type TransferData = z.infer<typeof TransferSchema>
export type TransferPageData = z.infer<typeof TransferPageSchema>
